import './styles.scss'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

function removeHtmlTags(str) {
  const doc = new DOMParser().parseFromString(str, 'text/html')

  return doc?.body?.textContent || ''
}

export default function MetaTagsComponent({ title, description, keywords, url, h1Content, ogContent }) {
  const { t } = useTranslation()

  const strippedTitle = removeHtmlTags(ogContent?.subject)
  const strippedDescription = removeHtmlTags(ogContent?.newsHtml)
  const ogImage = ogContent?.nwsFeedMedia?.[0]?.pathOfMedia || 'https://coffeeweb.s3.ap-south-1.amazonaws.com/coffeeweb_menu_icons/CoffeeWeb_Logo_White_Background_Blue_Text.png'

  return (
    <div>
      <Helmet defaultTitle={t('DEFAULT_COFFEE_WEB_TITLE')}>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="keywords" content={keywords} />
        <link rel="canonical" href={url} />

        <meta property="og:title" content={strippedTitle} />
        <meta property="og:description" content={strippedDescription} />
        <meta property="og:url" content={url} />
        <meta property="og:image" content={ogImage} />
        <meta property="og:type" content="website" />
      </Helmet>
      <h1 className="meta-tag-h1">{h1Content}</h1>
    </div>
  )
}
